module.exports = __webpack_public_path__ + "img/ulica.fb737f4c.jpg";